import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ArgumentType } from "#/entities/argument/model/argumentObject";
import { type ArrayData, type ArrayItemData, selectArrayStateByName } from "#/entities/dataStructures/array/model/arraySlice";
import { ArrayStructureView } from "#/entities/dataStructures/array/ui/ArrayStructureView";
import { MapStructureView } from "#/entities/dataStructures/map/ui/MapStructureView";
import { useAppSelector } from "#/store/hooks";
type NestedStructureProps = {
  item: ArrayItemData;
  colorMap?: ArrayData["colorMap"];
};
export const NestedStructure: React.FC<NestedStructureProps> = t0 => {
  const $ = _c(6);
  const {
    item: t1,
    colorMap
  } = t0;
  const {
    childName
  } = t1;
  const t2 = childName ?? "";
  let t3;
  if ($[0] !== t2) {
    t3 = selectArrayStateByName(t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const data = useAppSelector(t3);
  if (!data) {
    return null;
  }
  let Component = null;
  bb0: switch (data.argType) {
    case ArgumentType.MAP:
    case ArgumentType.OBJECT:
      {
        Component = MapStructureView;
        break bb0;
      }
    case ArgumentType.ARRAY:
    case ArgumentType.STRING:
    case ArgumentType.SET:
      {
        Component = ArrayStructureView;
      }
  }
  if (Component) {
    let t4;
    if ($[2] !== Component || $[3] !== colorMap || $[4] !== data) {
      t4 = <Component data={data} parentColorMap={colorMap} />;
      $[2] = Component;
      $[3] = colorMap;
      $[4] = data;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  return null;
};